var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "container" },
    [
      _c(
        "div",
        { staticClass: "handle-box" },
        [
          _c(
            "el-form",
            {
              ref: "queryCondition",
              staticClass: "searchForm",
              attrs: { model: _vm.queryCondition, "label-width": "120px" },
            },
            [
              _c(
                "el-row",
                [
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-row",
                        { attrs: { gutter: 20 } },
                        [
                          _c(
                            "el-col",
                            { attrs: { span: 6 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t("fpaManage.permanent.fpaNo"),
                                    prop: "fpaNo",
                                  },
                                },
                                [
                                  _c("el-input", {
                                    staticStyle: { width: "100%" },
                                    attrs: { clearable: "" },
                                    model: {
                                      value: _vm.queryCondition.fpaNo,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.queryCondition,
                                          "fpaNo",
                                          $$v
                                        )
                                      },
                                      expression: "queryCondition.fpaNo",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 6 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: { label: "Product", prop: "fpaName" },
                                },
                                [
                                  _c("el-input", {
                                    staticStyle: { width: "100%" },
                                    attrs: { clearable: "" },
                                    model: {
                                      value: _vm.queryCondition.fpaName,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.queryCondition,
                                          "fpaName",
                                          $$v
                                        )
                                      },
                                      expression: "queryCondition.fpaName",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 6 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  staticClass: "flexBox",
                                  attrs: {
                                    label: _vm.$t(
                                      "fpaManage.permanent.agreementLife"
                                    ),
                                    prop: "agreementStartDate",
                                  },
                                },
                                [
                                  _c("el-date-picker", {
                                    staticStyle: { width: "100%" },
                                    attrs: {
                                      type: "date",
                                      placeholder: _vm.$t("common.selDate"),
                                      "value-format": "yyyy-MM-dd",
                                      "picker-options":
                                        _vm.AgreementPickerOptionsStart,
                                    },
                                    model: {
                                      value: _vm.queryCondition.startDate,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.queryCondition,
                                          "startDate",
                                          $$v
                                        )
                                      },
                                      expression: "queryCondition.startDate",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 6 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  staticClass: "flexBox",
                                  attrs: {
                                    label: "To",
                                    prop: "agreementEndDate",
                                  },
                                },
                                [
                                  _c("el-date-picker", {
                                    staticStyle: { width: "100%" },
                                    attrs: {
                                      type: "date",
                                      placeholder: _vm.$t("common.selDate"),
                                      "value-format": "yyyy-MM-dd",
                                      "picker-options":
                                        _vm.AgreementPickerOptionsEnd,
                                    },
                                    model: {
                                      value: _vm.queryCondition.endDate,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.queryCondition,
                                          "endDate",
                                          $$v
                                        )
                                      },
                                      expression: "queryCondition.endDate",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-collapse-transition",
                    [
                      _vm.isShow
                        ? _c(
                            "el-col",
                            { attrs: { span: 24 } },
                            [
                              _c(
                                "el-row",
                                { attrs: { gutter: 20 } },
                                [
                                  _c(
                                    "el-col",
                                    { attrs: { span: 6 } },
                                    [
                                      _c(
                                        "el-form-item",
                                        {
                                          attrs: {
                                            label: "Supplier Code",
                                            prop: "supplierCode",
                                          },
                                        },
                                        [
                                          _c("el-input", {
                                            staticStyle: { width: "100%" },
                                            attrs: { clearable: "" },
                                            model: {
                                              value:
                                                _vm.queryCondition.supplierCode,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.queryCondition,
                                                  "supplierCode",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "queryCondition.supplierCode",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "el-col",
                                    { attrs: { span: 6 } },
                                    [
                                      _c(
                                        "el-form-item",
                                        {
                                          attrs: {
                                            label: "Supplier Name",
                                            prop: "supplierAbbreviation",
                                          },
                                        },
                                        [
                                          _c("el-input", {
                                            staticStyle: { width: "100%" },
                                            attrs: { clearable: "" },
                                            model: {
                                              value:
                                                _vm.queryCondition
                                                  .supplierAbbreviation,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.queryCondition,
                                                  "supplierAbbreviation",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "queryCondition.supplierAbbreviation",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "el-col",
                                    { attrs: { span: 6 } },
                                    [
                                      _c(
                                        "el-form-item",
                                        {
                                          attrs: {
                                            label: "Creator",
                                            prop: "createUser",
                                          },
                                        },
                                        [
                                          _c("el-input", {
                                            staticStyle: { width: "100%" },
                                            attrs: { clearable: "" },
                                            model: {
                                              value:
                                                _vm.queryCondition.createUser,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.queryCondition,
                                                  "createUser",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "queryCondition.createUser",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "el-col",
                                    { attrs: { span: 6 } },
                                    [
                                      _c(
                                        "el-form-item",
                                        {
                                          attrs: {
                                            label: "Status",
                                            prop: "status",
                                          },
                                        },
                                        [
                                          _c("ic-select", {
                                            staticStyle: { width: "100%" },
                                            attrs: {
                                              clearable: "",
                                              table: "TT_FPA",
                                              field: "QUERY_STATUS",
                                            },
                                            model: {
                                              value: _vm.queryCondition.status,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.queryCondition,
                                                  "status",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "queryCondition.status",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-row",
                { attrs: { type: "flex", justify: "center", align: "middle" } },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { size: "mini", type: "primary" },
                      on: { click: _vm.queryData },
                    },
                    [_vm._v("Search")]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: { size: "mini", type: "primary" },
                      on: { click: _vm.restQueryFormThis },
                    },
                    [_vm._v("Reset")]
                  ),
                  _c(
                    "span",
                    {
                      staticClass: "arrowDown",
                      on: {
                        click: function ($event) {
                          _vm.isShow = !_vm.isShow
                        },
                      },
                    },
                    [
                      _vm._v(_vm._s(_vm.isShow ? "Fold" : "Unfold")),
                      _c("i", {
                        class: _vm.isShow
                          ? "el-icon-arrow-up iconBtn"
                          : "el-icon-arrow-down iconBtn",
                      }),
                    ]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c("el-row", [
        _vm.activeName == "PQCN"
          ? _c(
              "div",
              [
                _c(
                  "el-button",
                  {
                    staticClass: "btn",
                    attrs: { size: "mini", type: "primary" },
                    on: { click: _vm.exportPqcn },
                  },
                  [_vm._v("Export")]
                ),
              ],
              1
            )
          : _vm._e(),
        _vm.activeName == "campaign"
          ? _c(
              "div",
              [
                _c(
                  "el-button",
                  {
                    directives: [
                      {
                        name: "acl",
                        rawName: "v-acl",
                        value: _vm.FpaLtoCampaignNew,
                        expression: "FpaLtoCampaignNew",
                      },
                    ],
                    staticClass: "btn",
                    attrs: { size: "mini", type: "primary" },
                    on: {
                      click: function ($event) {
                        return _vm.fpaLtoCampaignNew(-99999)
                      },
                    },
                  },
                  [_vm._v("New")]
                ),
                _c(
                  "el-button",
                  {
                    directives: [
                      {
                        name: "acl",
                        rawName: "v-acl",
                        value: _vm.FpaLtoCampaignDelete,
                        expression: "FpaLtoCampaignDelete",
                      },
                    ],
                    staticClass: "btn",
                    attrs: { size: "mini", type: "danger" },
                    on: {
                      click: function ($event) {
                        return _vm.fpaLtoCampaignDelete()
                      },
                    },
                  },
                  [_vm._v("Delete")]
                ),
                _c(
                  "el-button",
                  {
                    directives: [
                      {
                        name: "acl",
                        rawName: "v-acl",
                        value: _vm.FpaLtoCampaignRevoke,
                        expression: "FpaLtoCampaignRevoke",
                      },
                    ],
                    staticClass: "btn",
                    attrs: { size: "mini", type: "primary" },
                    on: { click: _vm.withdraw },
                  },
                  [_vm._v("Revoke")]
                ),
              ],
              1
            )
          : _vm._e(),
      ]),
      _c(
        "el-tabs",
        {
          staticClass: "fpaCa_Tab",
          on: { "tab-click": _vm.queryData },
          model: {
            value: _vm.activeName,
            callback: function ($$v) {
              _vm.activeName = $$v
            },
            expression: "activeName",
          },
        },
        [
          _c(
            "el-tab-pane",
            { attrs: { name: "campaign", label: "Campaign" } },
            [
              _c(
                "el-table",
                {
                  ref: "tableList",
                  attrs: {
                    data: _vm.tableList,
                    border: "",
                    "highlight-current-row": "",
                    "max-height": "540",
                  },
                  on: { "selection-change": _vm.handleSelectChange },
                },
                [
                  _c("el-table-column", {
                    attrs: { align: "center", type: "selection", width: "55" },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      "show-overflow-tooltip": "",
                      prop: "fpaNo",
                      label: _vm.$t("fpaManage.permanent.fpaNo"),
                      "min-width": "120px",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c(
                              "div",
                              {
                                staticClass: "a-link",
                                on: {
                                  click: function ($event) {
                                    return _vm.toDetail(
                                      scope.row.ttFpaLtoCampaignId
                                    )
                                  },
                                },
                              },
                              [_vm._v(_vm._s(scope.row.fpaNo))]
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: {
                      "show-overflow-tooltip": "",
                      prop: "fpaName",
                      label: "Product Or Commodity Purchased",
                      "min-width": "160px",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      "show-overflow-tooltip": "",
                      prop: "agreementStartDate",
                      label: _vm.$t("fpaManage.permanent.agreementStartDate"),
                      "min-width": "120px",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm._f("dateFormatFilter")(
                                    scope.row.agreementStartDate,
                                    "YYYY-MM-DD"
                                  )
                                ) +
                                " "
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: {
                      "show-overflow-tooltip": "",
                      prop: "agreementEndDate",
                      label: _vm.$t("fpaManage.permanent.agreementEndDate"),
                      "min-width": "120px",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm._f("dateFormatFilter")(
                                    scope.row.agreementEndDate,
                                    "YYYY-MM-DD"
                                  )
                                ) +
                                " "
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: {
                      "show-overflow-tooltip": "",
                      prop: "supplierAbbreviation",
                      label: "Supplier Name",
                      "min-width": "200px",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      "show-overflow-tooltip": "",
                      prop: "queryStatus",
                      label: "Status",
                      "min-width": "80px",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      "show-overflow-tooltip": "",
                      prop: "statusValue",
                      label: _vm.$t("fpaManage.permanent.logicStatus"),
                      "min-width": "100px",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-tab-pane",
            { attrs: { name: "PQCN", label: "NII" } },
            [
              _c(
                "el-table",
                {
                  ref: "fpaLtoPqcnList1",
                  attrs: {
                    data: _vm.fpaLtoPqcnList,
                    "row-style": _vm.changeRowBgColorByIsLocal,
                    "max-height": "500",
                    border: "",
                  },
                },
                [
                  _c("el-table-column", {
                    attrs: {
                      "show-overflow-tooltip": "",
                      align: "center",
                      prop: "fpaNo",
                      label: "FPA No.",
                      "min-width": "120px",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      "show-overflow-tooltip": "",
                      align: "left",
                      prop: "fpaName",
                      label: "FPA Name",
                      "min-width": "170px",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      "show-overflow-tooltip": "",
                      align: "center",
                      prop: "supplierName",
                      label: "Supplier",
                      "min-width": "300px",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      "show-overflow-tooltip": "",
                      align: "center",
                      prop: "plantName",
                      label: "Facility",
                      "min-width": "250px",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      "show-overflow-tooltip": "",
                      align: "center",
                      label: "Supplied DC",
                      "min-width": "350px",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _vm._v(_vm._s(_vm._f("dcsFilter")(scope.row.dcs))),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: {
                      "show-overflow-tooltip": "",
                      align: "center",
                      prop: "ingredient",
                      label: "Ingredient",
                      "min-width": "250px",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      "show-overflow-tooltip": "",
                      align: "center",
                      prop: "localItem",
                      label: "Local Item#",
                      "min-width": "100px",
                    },
                  }),
                  _c(
                    "el-table-column",
                    {
                      attrs: {
                        "show-overflow-tooltip": "",
                        align: "center",
                        label: "Price per CASE(RMB EXCL. VAT)",
                        "min-width": "250px",
                      },
                    },
                    [
                      _c("el-table-column", {
                        attrs: {
                          align: "center",
                          prop: "purchaseForcast",
                          label: "Price",
                          "min-width": "150px",
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _vm._v(
                                  _vm._s(
                                    _vm._f("thousandSeparator")(
                                      scope.row.purchaseForcast
                                    )
                                  )
                                ),
                              ]
                            },
                          },
                        ]),
                      }),
                      _c("el-table-column", {
                        attrs: {
                          align: "center",
                          prop: "unit",
                          label: "Unit",
                          "min-width": "150px",
                        },
                      }),
                    ],
                    1
                  ),
                  _c("el-table-column", {
                    attrs: {
                      "show-overflow-tooltip": "",
                      align: "center",
                      prop: "vat",
                      label: "VAT",
                      "min-width": "90px",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _vm._v(
                              _vm._s(
                                _vm._f("ic")(
                                  scope.row.vat,
                                  "TM_MATERIAL_RECORD",
                                  "URCHASE_TAX_RATE"
                                )
                              )
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c(
                    "el-table-column",
                    {
                      attrs: {
                        "show-overflow-tooltip": "",
                        align: "center",
                        label: "Price Valid Date",
                        "min-width": "150px",
                      },
                    },
                    [
                      _c("el-table-column", {
                        attrs: {
                          "show-overflow-tooltip": "",
                          align: "center",
                          prop: "priceValidDateFrom",
                          label: "From",
                          "min-width": "150px",
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _vm._v(
                                  _vm._s(
                                    _vm._f("dateFormatFilter")(
                                      scope.row.priceValidDateFrom
                                    )
                                  )
                                ),
                              ]
                            },
                          },
                        ]),
                      }),
                      _c("el-table-column", {
                        attrs: {
                          "show-overflow-tooltip": "",
                          align: "center",
                          prop: "priceValidDateTo",
                          label: "to",
                          "min-width": "150px",
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _vm._v(
                                  _vm._s(
                                    _vm._f("dateFormatFilter")(
                                      scope.row.priceValidDateTo
                                    )
                                  )
                                ),
                              ]
                            },
                          },
                        ]),
                      }),
                    ],
                    1
                  ),
                  _c("el-table-column", {
                    attrs: {
                      "show-overflow-tooltip": "",
                      align: "center",
                      prop: "tradeTerm",
                      label: "Trade Term",
                      "min-width": "250px",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _vm._v(
                              _vm._s(
                                _vm._f("ic")(
                                  scope.row.tradeTerm,
                                  "TM_MATERIAL_RECORD",
                                  "PRICE_TYPE"
                                )
                              )
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: {
                      "show-overflow-tooltip": "",
                      align: "center",
                      prop: "totalEstimatedQty",
                      label: "Total Estimated Qty(Case)",
                      "min-width": "200px",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      "show-overflow-tooltip": "",
                      align: "center",
                      prop: "totalEstimatedAmount",
                      label: "Total Estimated Amount (RMB)",
                      "min-width": "250px",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _vm._v(
                              _vm._s(
                                _vm._f("thousandSeparator")(
                                  _vm._f("fix")(
                                    scope.row.totalEstimatedAmount,
                                    2
                                  )
                                )
                              )
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: {
                      "show-overflow-tooltip": "",
                      align: "center",
                      prop: "transportaionMethod",
                      label: "Delivery Type",
                      "min-width": "150px",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _vm._v(
                              _vm._s(
                                _vm._f("ic")(
                                  scope.row.transportaionMethod,
                                  "TM_MATERIAL",
                                  "DIS_TYPE"
                                )
                              )
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: {
                      "show-overflow-tooltip": "",
                      align: "center",
                      prop: "freight",
                      label: "Freight",
                      "min-width": "150px",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _vm._v(
                              _vm._s(
                                _vm._f("thousandSeparator")(scope.row.freight)
                              )
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: {
                      "show-overflow-tooltip": "",
                      align: "center",
                      prop: "totalCost",
                      label: "Total Cost(without VAT)",
                      "min-width": "250px",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _vm._v(
                              _vm._s(
                                _vm._f("thousandSeparator")(scope.row.totalCost)
                              )
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: {
                      "show-overflow-tooltip": "",
                      align: "center",
                      label: "Promotion Date From",
                      "min-width": "200",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _vm._v(
                              _vm._s(
                                _vm._f("dateFormatFilter")(
                                  scope.row.promotionDateFrom
                                )
                              )
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: {
                      "show-overflow-tooltip": "",
                      align: "center",
                      label: "Promotion Date To",
                      "min-width": "200",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _vm._v(
                              _vm._s(
                                _vm._f("dateFormatFilter")(
                                  scope.row.promotionDateTo
                                )
                              )
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: {
                      "show-overflow-tooltip": "",
                      align: "center",
                      prop: "remark",
                      label: "Remark",
                      "min-width": "250px",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "pagination" },
        [
          _c("el-pagination", {
            attrs: {
              "current-page": _vm.queryCondition.pageNum,
              "page-sizes": _vm.pageSizeList,
              "page-size": _vm.queryCondition.pageSize,
              layout: _vm.pageLayout,
              total: _vm.totalCount,
            },
            on: {
              "size-change": _vm.pageSizeChange,
              "current-change": _vm.pageNumberChange,
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }